import { getToken } from '~/src/dash/api/auth/auth';
import { getOAuthIntrospect, getOAuthToken } from '~/src/dash/api/console-api';

export function authenticate(): Promise<any> {
  const accessToken = getToken().access_token;
  const refreshToken = getToken().refresh_token;
  if (!accessToken && !refreshToken) {
    return Promise.reject();
  }
  return getOAuthIntrospect({
    body: {
      token: accessToken,
    },
  }).then((json: any) => {
    if (json.active) {
      return Promise.resolve(json);
    }
    return getOAuthToken({
      query: {
        grant_type: 'refresh_token',
        refresh_token: getToken().refresh_token,
      },
    }).then((res: any) => {
      if (res.error) {
        return Promise.reject();
      }
      return Promise.resolve(res);
    });
  });
}
